<template>
  <div class="marginNormalTop row">
    <div v-if="hasTelephoneBid">
      <div class="telephoneBiddingStatus">
        <!-- <div class="telephoneBiddingStatusMessage">
					You are currently scheduled for telephone bidding on this lot at the following number<span v-if="hasTelephoneBid.primaryphone !== '' && hasTelephoneBid.secondaryphone !== ''">s</span>:<br />{{hasTelephoneBid.primaryphone}}<span v-if="hasTelephoneBid.secondaryphone !== ''"><br />{{hasTelephoneBid.secondaryphone}}</span>
				</div> -->
      </div>
    </div>
    <div
      v-else-if="authenticated && BiddingStatus.is_telephone_bidding_open"
      class="telephoneButton"
    >
      <form @submit.prevent="placeBid('place_bid')">
        <span v-if="bidIsPending">
          <button
            :disabled="'true'"
            class="smallButton disabledButton"
            :class="{ 'telephoneButton': showCancelButton !== true}"
            type="submit"
          >{{ buttonText }}</button>
        </span>
        <div v-else>
          <div>
            <div
              v-if="showCancelButton"
              :class="{ 'telephoneButton': showCancelButton !== true }"
            >
              <div
                class="telephoneButtonActionButton"
                :class="{ 'telephoneButton': showCancelButton !== true }"
              >
                <button
                  class="backgroundColorSuccess bidButton"
                  :class="{ 'telephoneButton': showCancelButton !== true }"
                  type="submit"
                  @click="enableTelephoneBid"
                >
                  {{ buttonText }}
                </button>
              </div>
              <div class="telephoneButtonCancelButton">
                <span
                  v-if="showCancelButton"
                  class="cancelButton"
                  @click="cancelBid"
                >Cancel</span>
              </div>
            </div>
            <div
              v-else
              class="telephoneButton"
            >
              <div class="telephoneButtonActionButton telephoneButton">
                <button
                  class="smallButton telephoneButton"
                  type="submit"
                  @click="enableTelephoneBid"
                >
                  {{ buttonText }}
                </button>
              </div>
              <div class="telephoneButtonCancelButton">
                <span
                  v-if="showCancelButton"
                  class="cancelButton"
                  @click="cancelBid"
                >Cancel</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bid',
	components: {
	},
  props: [
    'item_id',
    'primaryPhone',
    'secondaryPhone',
    'showCancelButton',
    'Card'
  ],
  data () {
    return {
      bidConfirmed: false,
      isTelephoneBid: true,
      add_card: false,
      phoneNumbers: {
        primary_phone: '',
        secondary_phone: ''
      },
      agree_to_terms: false
    }
  },
  computed: {
  	apiResponse: function () {
			return this.$store.getters.apiResponse
		},
    phoneBids: function () {
      if (!this.$store.getters.customerPhoneBids[this.item_id]) {
        return {
          primary_phone: '',
          secondary_phone: ''
        }
      } else {
        return {
          primary_phone: this.$store.getters.customerPhoneBids[this.item_id].primaryphone,
          secondary_phone: this.$store.getters.customerPhoneBids[this.item_id].secondaryphone
        }
      }
    },
    hasTelephoneBid: function () {
      //return false
      return this.$store.getters.customerPhoneBids(this.item_id)
    },
  	itemBiddingStatus: function () {
			return this.$store.getters.itemBiddingStatus(this.item_id)
		},
    BiddingStatus: function () {
      if (!this.$store.getters.biddingStatuses['ITEMID_' + this.item_id]) {
        return {
          'current_asking_bid': '',
          'current_high_bid_amount': '',
          'current_high_bid_recognized': '',
          'current_high_bidcard': '',
          'current_live_lot': false,
          'display_bid_count': '',
          'has_passed': false,
          'has_sold': false,
          'is_bidding_open': false,
          'is_telephone_bidding_open': false,
          'clerked_amount': '',
          'pending_bid': false,
          'seconds_remaining': 0,
          'bidding_end_date': '',
          'auction_id': ''
        }
      }
      return this.$store.getters.biddingStatuses['ITEMID_' + this.item_id]
    },
    buttonText: function () {
      return this.$store.getters.phoneBidButtonText(this.item_id)
    },
    authenticated: function () {
      return true
      //return this.$store.getters.isAuthenticated
    },
    isWinningBidder: function () {
      return this.BiddingStatus.current_high_bidcard ===
        this.$store.getters.customerBidCards[this.BiddingStatus.auction_id]
    },
    bidIsPending: function () {
      return !!((
        this.isWinningBidder &&
        this.BiddingStatus.current_high_bid_recognized === 'n'
      ) || (
        this.BiddingStatus.pending_bid === true
      ))
    },
    customer: function () {
      return this.$store.getters.customer
    }
  },
  watch: {
    // 'phoneBids.primary_phone': function () {
    //   this.computePhoneNumbers()
    // },
    // hasTelephoneBid: function () {
    //   this.computePhoneNumbers()
    // }
  },
  mounted () {
    // this.computePhoneNumbers()
  },
  methods: {
    // computePhoneNumbers: function () {
    //   if (!this.$store.getters.customerPhoneBids[this.item_id]) {
    //     this.phoneNumbers.primary_phone = ''
    //     this.phoneNumbers.secondary_phone = ''
    //   } else {
    //     this.phoneNumbers.primary_phone = this.$store.getters.customerPhoneBids[this.item_id].primary_phone
    //     this.phoneNumbers.secondary_phone = this.$store.getters.customerPhoneBids[this.item_id].secondary_phone
    //   }
    // },
    enableTelephoneBid: function () {
      this.$store.dispatch('startPhoneBid', { inventory_id: this.item_id })
    },
    // cancelBid: function () {
    //   this.$emit('resetForm')
    //   this.$emit('resetPhoneForm')
    //   this.$store.dispatch('cancelBid')
    //   this.$store.dispatch('cancelPhoneBid', { inventory_id: this.item_id })
    // },
    resetPhoneForm: function () {
      this.$emit('resetPhoneForm')
    },

    cancelBid: function () {
      this.$store.dispatch('cancelPhoneBid', { inventory_id: this.item_id })
      this.$emit('resetPhoneForm')
      this.$emit('resetForm')
      // clear the last api response
			this.$store.dispatch('clearApiResponse', 'place_bid')
    },
    placeBid (context) {
      let payload = {
        'inventory_id': this.item_id,
        'confirmed': this.itemWaitingForConfirmation,
        'auction_id': this.itemBiddingStatus.auction_id,
        'bid_amount': this.bidAmount,
        'primary_phone': this.primaryPhone,
        'secondary_phone': this.secondaryPhone,
        'telephone_bid': true,
        'card': {
          'card_number': this.Card.card_number,
          'expire_month': this.Card.expire_month,
          'expire_year': this.Card.expire_year,
          'cvv2': this.Card.cvv2,
          'billing_address': this.Card.billing_address,
          'billing_zip': this.Card.billing_zip,
          'country': this.Card.country
        },
        'add_card': this.itemRequiresCard,
        'agree_to_terms': this.itemWaitingForAgreement
      }
      if(this.assume_customer) {
        payload.assume_customer = this.assume_customer
      }
		  payload.context = context
      this.$store.dispatch('placeBid', payload)
    },
  }
}
</script>

<style scoped>
</style>
